import { render, staticRenderFns } from "./TheSiteFooter.vue?vue&type=template&id=681cdd6f"
import script from "./TheSiteFooter.vue?vue&type=script&lang=js"
export * from "./TheSiteFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('681cdd6f')) {
      api.createRecord('681cdd6f', component.options)
    } else {
      api.reload('681cdd6f', component.options)
    }
    module.hot.accept("./TheSiteFooter.vue?vue&type=template&id=681cdd6f", function () {
      api.rerender('681cdd6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/partials/TheSiteFooter.vue"
export default component.exports